import { Grid } from '@mui/joy';
import MainTopicsContent from './MainTopicsContent';

export const TopicsOverview = () => (
  <Grid
    container
    sx={{
      minHeight: '100%',
      paddingTop: '1rem',
      padding: '1rem',
      paddingBottom: '2rem',
    }}
  >
    <Grid xs={0} lg={2}></Grid>
    <Grid xs={12} lg={8}>
      <MainTopicsContent />
    </Grid>
    <Grid xs={0} lg={2}></Grid>
  </Grid>
);
